import { http } from '@/core/helpers/axiosHelper';
import { PaginatedResponse } from '@/core/models/PaginatedResponse';
import { CalculatedFieldConditionType } from './calculated-field-condition-type.interface';

export class CalculatedFieldConditionTypeService {
   async getCalculatedFieldConditionTypes() {
      const response = await http.get<PaginatedResponse<CalculatedFieldConditionType>>(`/calculated-field-condition-types`);
      return response.data;
   }

   async getCalculatedFieldConditionType() {
      throw Error('Method not implemented');
   }

   async postCalculatedFieldConditionType() {
      throw Error('Method not implemented');
   }

   async putCalculatedFieldConditionType() {
      throw Error('Method not implemented');
   }

   async deleteCalculatedFieldConditionType() {
      throw Error('Method not implemented');
   }
}
